import React from 'react';
import FilterModel from 'app/components/FilterModel';

const CollectVoucher = ({
  values,
  setValues,
  isFilterOpen,
  setIsFilterOpen,
  onSubmit,
}) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    if (form.checkValidity()) {
      onSubmit({ values });
    } else {
      form.reportValidity();
    }
  };

  const handleCancel = () => {
    setIsFilterOpen(false);
  };
  const resetfilter = () => {};
  return (
    <>
      {isFilterOpen && (
        <FilterModel
          isFilterOpen={isFilterOpen}
          setIsFilterOpen={setIsFilterOpen}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          resetfilter={resetfilter}
          filter={false}
          heading='Collect Voucher'
        >
          <>
            <div className='offcanvas-item'>
              <label>Phone Number:</label>
              <input
                required
                type='number'
                value={values?.phoneNumber}
                disabled={true}
              />
            </div>
            <div className='offcanvas-item'>
              <label>Voucher Collection Code :</label>
              <input
                type='text'
                value={values?.voucherCode}
                required
                onChange={(e) =>
                  setValues({ ...values, voucherCode: e.target.value })
                }
              />
            </div>
            <div className='offcanvas-item'>
              <label>Voucher Serial Number::</label>
              <input
                required
                type='text'
                onChange={(e) =>
                  setValues({ ...values, serialNumber: e.target.value })
                }
              />
            </div>
          </>
        </FilterModel>
      )}
    </>
  );
};

export default CollectVoucher;
